import React, { useEffect, useRef, useState } from "react";
import {RunnerUpHeader, TableWork, UnderLine } from "../../ui";
import Button from "../../library/components/Button";
import SelectField from "../../library/components/Select";
import TextAreaField from "../../library/components/textarea/index";
import {
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
} from "../../constants/constants";
import { useDispatch } from "react-redux";
import { createAlert } from "../../features/alert/alerts";
import { Validators } from "../../library/utilities/Validator";
import {
  FILED_IS_REQUIRED,
  NO_RECORDS_FOUND,
} from "../../constants/constants";

import {
  useNullificationMutation,
  useGetAllNullificationQuery,
  useGetAllCommonMasterQuery,
} from "../../services/nullificationservice";
import {
  useGetStatesRequestQuery,
} from "../../services/announceElection";
import "../../css/common.css";
import "./Nullification.css";
import { parseJwt } from "../utilities/utils";
import LeftMenu from "../AnalyticsModule/Left";
import CustomModal from "../../library/components/Modal/modal";
import ConfirmationModal from "../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import moment from 'moment'
import UploadFile from "../../library/components/FileUpload";
import { useSubmitObjectStoreUploadMutation } from "../../services/objectStoreServices";
import { downloadFile } from "../utilities/utils";
import Table from '../../ui/datatable/DataTable'
import RunnerUpHeaderNew from "../../ui/runnerUpHeader/RunnerUpHeaderNew";

const columns1 = [
  {
    Header: 'S.No',
    accessor: 'S_No',
  },
  {
    Header: 'State Name',
    accessor: 'state_name',
  },
  {
    Header: 'Election Type',
    accessor: 'Election_Type',
  },
  {
    Header: 'Constituency Type',
    accessor: 'Constituency_Type',
  },
  {
    Header: 'Constituency No & Name',
    accessor: 'Constituency_No_Name',
  },
  {
    Header: 'Reason for Nullification',
    accessor: 'Remarks',
  },
  {
    Header: 'Date Of Nullification',
    accessor: 'Date_Of_Notification',
  },
  {
    Header: 'Address Finalize Status',
    accessor: 'Address_Finalize_Status',
  },
  {
    Header: 'Ballot Finalize Status',
    accessor: 'Ballot_Finalize_Status',
  },
  {
    Header: 'Epb Transmission Status',
    accessor: 'Epb_Transmission_Status',
  },
  {
    Header: 'Document',
    accessor: 'Document',
  },
  {
    Header: 'Nullification Status',
    accessor: 'Status',
  },
]

const tableHeader = [
  "S. No.",
  "State Name",
  "Election Type",
  "Constituency Type",
  "Constituency No & Name",
  "Reason for Nullification",
  "Date Of Nullification",
  "Address Finalize Status",
  "Ballot Finalize Status",
  "Epb Transmission Status",
  "Nullification For",
  "Document",
  "Nullification Status",
];
const selectConstituencyType = [
  { value: "", label: "Select Constituency" },
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];
const selectElectionType = [
  { value: "", label: "Select Election Type" },
  { value: "Gen", label: "General" },
  { value: "Bye", label: "Bye" },
];

// const selectNullificationFor = [
//   { value: "", label: "Select Nullification For" },
//   { value: "RO", label: "RO Activity" },
//   { value: "ERO", label: "RO & ERO Activity (both)" },
// ];

const Nullification = () => {
  const stateList = [{ value: "", label: "Select State" }];
  const [constituencyList, setConstituencyList] = useState([
    { value: "", label: "Select Constituency" },
  ]);
  // const parliamentaryList = [{ value: "", label: "Select Constituency" }];
  // const electionList = [{ value: "", label: "Select Election Type" }];

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

  // const constituencyTypeList = [
  //   { value: "", label: "Select Constituency Type" },
  // ];
  const [NullificationDataRequest,setNullificationDataRequest] = useState([]);
  const stateCd = parseJwt(localStorage.access_token).authorizedStates?.[0];
  const [data, setData] = useState({
    SelectedState: stateCd,
    elec: "",
    const: "",
    Selectedcons: "",
    remarks: "",
  });
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [errorValue, setErrorValue] = useState({});
  const dispatch = useDispatch();
  const ref = useRef()
  let userState = parseJwt(localStorage.access_token).authorizedStates?.[0]
  //const getElectionList = useGetAllCommonMasterQuery();
  const { data: getStateList } = useGetStatesRequestQuery();
  const { data: getAllCommonMaster } = useGetAllCommonMasterQuery();
  var [uploadData, response] = useSubmitObjectStoreUploadMutation();
  //const getConstituencyTypeList = useGetAllCommonMasterQuery();
  // const { data: getConstituencyByStateId } = useGetConstituencyRequestQuery(
  //   stateCd,
  //   { skip: data.const === "AC" ? false : true }
  // );
  // const { data: getPcdata } = useGetPcByStateQuery(stateCd, {
  //   skip: data.const === "PC" ? false : true,
  // });
  const [nullification] = useNullificationMutation();
  const { data: Nullifications, refetch} = useGetAllNullificationQuery();
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()

  useEffect(() => {
    let constList = [{ value: "", label: "Select Constituency" }];
    if (getAllCommonMaster) {
      if (data.const !== "" && data.elec !== "") {
        getAllCommonMaster?.payload
          ?.filter(
            (item) =>
              item.constType === data.const &&
              item.electionType == String(data.elec).toUpperCase()
          )
          .map((item) =>
            constList.push({
              label: `${item.constNo} - ${item.constName}`,
              value: item.constNo,
            })
          );
        setConstituencyList(constList);
      }
    }
  }, [getAllCommonMaster, data.const, data.elec]);

  useEffect(() => {
    if (data.SelectedState === "") {
      const stateCd = parseJwt(localStorage.access_token).authorizedStates?.[0];
      setData((prevState) => ({
        ...prevState,
        SelectedState: stateCd,
      }));
    }
  }, [data]);

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const getErrorValue = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setErrorValue({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setErrorValue(error);
    }
  };

  getStateList?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    });
  });

  const getDateTime=(date)=>{
    let splittedDateTime=date.split(' ')
    let sDate=splittedDateTime[0].split('-')
    return sDate[2]+'-'+sDate[1]+'-'+sDate[0]+' '+splittedDateTime[1]
  }

  // getElectionList?.data?.payload?.map((item) => {
  //   electionList.push({
  //     value: item.electionTypeAbbre,
  //     label: "General",
  //     value: item.electionTypeAbbre,
  //     label: "Bye"
  //   });
  // });
  // getConstituencyTypeList?.data?.payload?.constType?.map((item) => {
  //   constituencyTypeList.push({
  //     value: item,
  //     label: item,
  //   });
  // });

  // getConstituencyByStateId?.map((item) => {
  //   constituencyList.push({
  //     label: `${item.asmblyNo} - ${item.asmblyName}`,
  //     value: item.asmblyNo,
  //   });
  // });
  // getPcdata?.map((item) => {
  //   parliamentaryList.push({
  //     label: `${item.prlmntNo} - ${item.parliamentName}`,
  //     value: item.prlmntNo,
  //   });
  // });
 useEffect(()=>{
  if(Nullifications){
    const NullificationData = []
    Nullifications?.payload?.map((item, i) => {
      NullificationData.push({
        "S_No": i + 1,
        "state_name": getStateList?.filter((item) => {
          return item.stateCd === stateCd;
        })?.[0].stateName,
        "Election_Type": item.electionType,
        "Constituency_Type": item.constType,
        "Constituency_No_Name": `${item.constNo} - ${item.constName}`,
        Remarks: item.reasonForNullification,
        "Date_Of_Notification": moment(new Date(item.submittedOn)).format("DD-MM-YYYY hh:mm A"),
        "Address_Finalize_Status": item.addressFinalize,
        "Ballot_Finalize_Status": item.ballotFinalize,
        "Epb_Transmission_Status": item.epbPaperFinalize,
        // "Nullification_For": item.nullificationFor,
        "Document":item.document !==null ? <i className="fa fa-download" style={{ cursor:"pointer"}} onClick={()=>{downloadFile(item?.document)}} />:"NA",
        Status: <span className={item.status}>{item.status}</span>,
      });
      setNullificationDataRequest(NullificationData)
      setTotalNoOfRecords(Nullifications?.payload?.length)
    });
  }
 },[Nullifications])

  const onSuccess = (msg) => {
    dispatch( 
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };
  ///////////////////////////Reason word

  const onUpdate = async () => {
    let error = {};
    if (!data.SelectedState || data.SelectedState === "") {
      error["SelectedState"] = "This field is required";
    }

    if (!data.elec || data.elec === "") {
      error["elec"] = "This Field is required";
    }
    
    // if (!data.nullificationFor || data.nullificationFor === "") {
    //   error["nullificationFor"] = "This Field is required";
    // }

    if (!data.const || data.const === "") {
      error["const"] = "This Field is required";
    }

    if (!data.Selectedcons || data.Selectedcons === "") {
      error["Selectedcons"] = "This Field is required";
    }

    if (!data.nullifyDocument || data.nullifyDocument === "") {
      error["nullifyDocument"] = "This Field is required";
    }

    if (!data.remarks || data.remarks === "") {
      error["remarks"] = "This Field is required";
    }

    setShowConfirmationPopup(false);
    if (Object.keys(error).length) {
      setErrorValue(error);
      return;
    }
    // if (
    //   data.SelectedState === "" ||
    //   data.elec === "" ||
    //   data.const === "" ||
    //   data.Selectedcons === "" ||
    //   data.remarks === ""
    // ) {
    //   alert(FILL_ALL_FIELDS);
    //   return false;
    // }

    let formdata = new FormData();
    let files = data?.nullifyDocument
    formdata.append("bucketName", "");
    formdata.append("file", files);
    formdata.append("fileType", files?.type);
    formdata.append("fileName", files?.name);
    formdata.append("stateCode", userState);
    formdata.append("acNo", data.Selectedcons);
    formdata.append("type", `ETPBMS`);

    if (formdata !== null && formdata !== {}) {
      uploadData(formdata)
        .then((res) => {
          if (res?.error) {
            setIsFileUpload(false);
          }  else
          {
           setIsFileUpload(false);
           ref.current.removeFile();
           nullification({
            stateCode: data.SelectedState,
            electionType: data.elec,
            constType: data.const,
            constNo: data.Selectedcons,
            // nullificationFor: data.nullificationFor,
            reasonForNullification: data.remarks,
            document:res?.data?.refId
          }).unwrap().then((responseData) => {
            onSuccess(responseData?.data?.message);
            refetch();
            setData({
              remarks: "",
              elec: "",
              const: "",
              Selectedcons: "",
              SelectedState: "",
            });
          })
          .catch((err) => {});
          }
        }).catch((err) => {
          setIsFileUpload(false);
        });
      }
       else {
      setIsFileUpload(false);
    }
  };
  const message = "This field is required.";
  return (
    <LeftMenu>
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          size="500px"
          closeIcon={false}
          modalTitle={"Do you want to send a Nullification Request ?"}
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={() => setShowConfirmationPopup(false)}
              yesOption={onUpdate}
            />
          }
        />
      }
      <div className="container box shadow ">
        <RunnerUpHeaderNew title={"Nullification"}
        state={<span
                    
                  >
                    State: {Nullifications?.state}{" "}
                    </span>}
          
          
          />
        <div className="row mt-1">
          <div className="col-md-4 mt-4">
            <label  className="requiredMark">State</label>
          </div>

          <div className="col-md-8">
            <SelectField
              value={data?.SelectedState}
              handleChange={(val) => handleChange("SelectedState", val)}
              placeholder="Select State"
              options={stateList}
              disabled={true}
              name="SelectedState"
              getError={(value) => getErrorValue("SelectedState", value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getErrorValue={(val) => getErrorValue("SelectedState", val)}
              Error={errorValue}
            />
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-md-4 mt-4">
            <label  className="requiredMark">Select Election Type</label>
          </div>

          <div className="col-md-8">
            <SelectField
              value={data.elec}
              placeholder="Select Election Type"
              options={selectElectionType}
              name="elec"
              handleChange={(val) => handleChange("elec", val)}
              getError={(value) => getErrorValue("elec", value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getErrorValue={(val) => getErrorValue("elec", val)}
              Error={errorValue}
            />
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-md-4 mt-4">
            <label  className="requiredMark">Select Constituency Type</label>
          </div>

          <div className="col-md-8">
            <SelectField
              value={data.const}
              placeholder="Select Constituency Type"
              options={selectConstituencyType}
              name="const"
              handleChange={(val) => handleChange("const", val)}
              getError={(value) => getErrorValue("const", value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getErrorValue={(val) => getErrorValue("const", val)}
              Error={errorValue}
            />
          </div>
        </div>
        <div className="row mt-1 my-2">
          <div className="col-md-4 mt-4 ">
            <label  className="requiredMark">Select Constituency No. and Name</label>
          </div>

          <div className="col-md-8">
            <SelectField
              value={data.Selectedcons}
              handleChange={(val) => handleChange("Selectedcons", val)}
              options={constituencyList.sort((a, b) => a.value - b.value)}
              name="Selectedcons"
              placeholder="Select Constituency"
              getError={(value) => getErrorValue("Selectedcons", value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getErrorValue={(val) => getErrorValue("const", val)}
              Error={errorValue}
            />
          </div>
        </div>

        {/* <div className="row mt-1">
          <div className="col-md-4 mt-4">
            <label  className="requiredMark">Select Nullification For</label>
          </div>

          <div className="col-md-8">
            <SelectField
              value={data.nullificationFor}
              placeholder="Select Election Type"
              options={selectNullificationFor}
              name="nullificationFor"
              handleChange={(val) => handleChange("nullificationFor", val)}
              getError={(value) => getErrorValue("nullificationFor", value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getErrorValue={(val) => getErrorValue("nullificationFor", val)}
              Error={errorValue}
            />
          </div>
        </div> */}

        <div className="row mt-1 my-4">
          <div className="col-md-4 mt-2 ">
            <label className="requiredMark">Upload Nullification Document</label>
          </div>
          <div className="col-md-8">
        <UploadFile
                  name="nullifyDocument"
                  required={true}
                  labelClass="col-10 box"
                  onChange={(val) =>
                    handleChange("nullifyDocument", val.target.files[0])
                  }
                  accept=".jpeg,.jpg, .png, .pdf"
                  validTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
                  size={5000}
                  reference={ref}
                  validators={[
                    {
                      check: Validators.required,
                      message: "this field is required",
                    },
                  ]}
                  getError={(val) => getErrorValue("nullifyDocument", val)}
                  Error={errorValue}
                />
                <p className="text-danger px-3">
                            (only .jpg, jpeg, .png and .pdf extension supported)
                          </p>
</div>
</div>
        <div className="row  mt-1">
          <div className="col-md-4 mt-4">
            <label  className="requiredMark">Reason</label>
          </div>

          <div className="col-md-8 nullification">
            <TextAreaField
              type="textrea"
              name="remarks"
              placeholder="Enter Reason"
              rows="4"
              cols="40"
              maxLength="250"
              value={data.remarks}
              onChange={(val) => handleChange("remarks", val)}
              getError={(value) => getErrorValue("remarks", value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
                {
                  check: Validators.required,
                  message: "This field is required",
                },
                {
                  check: Validators.nospecialReason,
                  message: "Special Character are not allowed",
                }
              ]}
              getErrorValue={(val) => getErrorValue("remarks", val)}
              Error={errorValue}             
            ></TextAreaField>

            <div className="col-md-6" style={{ marginTop: "-16px" }}>
              <p className="text-danger ml-1">
                *max length 250 characters
              </p>
              
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 offset-4 request_button">
            <Button
              value="Send Request"
             // onClick={onUpdate}
             onClick={() => setShowConfirmationPopup(true)}
              id="abc"
              btnClass="btn-class mb-3"
            />
          </div>
              <p className="text-danger ml-2 mr-2" style={{fontSize:"15px"}}>
                *CEO explaining the background will write to ECI to nullify the postal ballot. However, only after the approval of Commission further action will be taken as per the direction of the Commission.
              </p>
        </div>
        <UnderLine />

        <span className="trans-spn mt-2 ml-2">
          <strong>Nullified Data Requests</strong>
          <p></p>
        </span>
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns1}
          emptyMessage="No Record Found"
          records
          data={NullificationDataRequest?.length === 0 ? [] : NullificationDataRequest}
          size={10}
          tableClassNameCheck="contenttable-eroll"
          pagination
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
    </LeftMenu>
  );
};

export default Nullification;
